import { Avatar } from '@mui/material';
import { useRecordContext } from 'react-admin';
import type { SupplyLight, SupplySummary } from '@wwf/sdk';
import { useResource } from '@app/misc/useResource';

export interface SupplyAvatarProps {
    record?: SupplyLight | SupplySummary;
    width?: number;
    height?: number;
    variant?: 'sm' | 'md' | 'lg' | 'xl';
    style?: React.CSSProperties;
    title?: string;
    'aria-label'?: string;
}

const sizes = {
    sm: 30,
    md: 40,
    lg: 80,
    xl: 120,
} as const;

export const SupplyAvatar = (props: SupplyAvatarProps) => {
    const record = useRecordContext<SupplyLight | SupplySummary>(props);
    const imageId = record?.image?.id;
    const { data: src } = useResource(imageId);

    const {
        width,
        height,
        variant = 'md',
        style,
        title,
        'aria-label': ariaLabel,
    } = props;

    const _width = width ?? sizes[variant];
    const _height = height ?? sizes[variant];

    return (
        <Avatar
            variant="rounded"
            title={title}
            aria-label={ariaLabel}
            sx={{ ...style, width: _width, height: _height, borderRadius: 2 }}
            src={src ?? undefined}
        >
            {src ? (
                <img src={src} alt={record?.name ?? ''} />
            ) : (
                (record?.name ?? '').charAt(0).toUpperCase()
            )}
        </Avatar>
    );
};
